import { render } from "./FetchData.vue?vue&type=template&id=f68339a4&scoped=true"
import script from "./FetchData.vue?vue&type=script&lang=js"
export * from "./FetchData.vue?vue&type=script&lang=js"

import "./FetchData.vue?vue&type=style&index=0&id=f68339a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f68339a4"

export default script